import React, {Component} from "react";
import "./Login.css";

export default class Login extends Component {
    render() {
        return (
            <div>
                <div className="m-b">
                    <strong>Landlord invite</strong>
                    <p className="text-xs m-t">This page is no longer supported.</p>
                    <ul class="text-xs m-t">
                        <li>Please go to <a class="text-info" href="https://app.flatfair.co.uk" target="_blank">app.flatfair.co.uk</a></li>
                        <li>click 'Sign up as agent' and complete registration process</li>
                        <li>Log in and click 'Invite landlord'</li>
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/RedirectToPlatform.js